import { ButtonVariant } from "@amzn/stencil-react-components/button";
import { Row } from "@amzn/stencil-react-components/layout";
import { Button } from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

interface StepActionsProps {
  onBack?: () => void;
  onNext?: () => void;
  onSaveDraft?: () => void;
  nextLabel?: string;
  isNextDisabled?: boolean;
}

export const StepActions: FC<StepActionsProps> = ({
  onBack,
  onNext,
  onSaveDraft,
  nextLabel = getString("useCases.contributeForm.next"),
  isNextDisabled,
}) => (
  <div className="contribute-use-case-page__actions">
    <Row gridGap="S200">
      {onBack && (
        <Button variant={ButtonVariant.Secondary} onClick={onBack} touchpoint="use-case-back">
          {getString("useCases.contributeForm.back")}
        </Button>
      )}
      {onSaveDraft && (
        <Button variant={ButtonVariant.Tertiary} onClick={onSaveDraft} touchpoint="use-case-save-draft">
          {getString("useCases.contributeForm.saveDraft")}
        </Button>
      )}
    </Row>
    {onNext && (
      <Button variant={ButtonVariant.Primary} onClick={onNext} disabled={isNextDisabled} touchpoint="use-case-next">
        {nextLabel}
      </Button>
    )}
  </div>
);
